import React, { useEffect, useState, useRef } from 'react'
import './PasswordExpired.css'

import { Button } from 'primereact/button';
import {Toast} from 'primereact/toast'
import { Password } from 'primereact/password'

import { useSelector, useDispatch } from 'react-redux'
import { saveExpiredPassword,updateExpiredPasswordUserInfo,getExpiredPasswordUserInfo,getUserDetails } from '../../../actions'
import { Messages } from 'primereact/messages';
import {useHistory} from 'react-router-dom'
import MaskIcon from '../../../components/MaskIcon'

const PasswordExpired = () => {

  const messages = useRef(null)
  const toast = useRef(null)
  const dispatch = useDispatch()
  const userdetails = useSelector(state=> state.userReducers)
  const userinfo = useSelector(state => state.expiredPasswordUserInfoReducers)
  const currentpasswordRef = useRef(null)
  const confirmpasswordRef = useRef(null)
  const passwordRef = useRef(null)
  const [invalid, setInvalid] = useState({
    password: false,
    currentpassword:false,
    confirmpassword: false,
    passwordmatch: false,
    passwordpolicy: false
  })
  const [passwordRules, setPasswordRules] = useState({
    onelowerchar: false,
    oneupperchar: false,
    onenumber: false,
    onespecialchar: false,
    beginwithchar: false,
    min12char: false,
    mustnotcontainname: false,
    mustnotcontainid: false
  })

  const resetValidation = (fields) => {
    var fieldsUpdate = {}
    if (typeof (fields) === 'string') {
      fieldsUpdate[`${fields}`] = false
    } else if (Array.isArray(fields)) {
      fields.forEach(item => {
        fieldsUpdate[`${item}`] = false
      })
    }
    setInvalid(Object.assign({}, invalid, fieldsUpdate))
  }

  const charIsLetter = (char) => {
    if (typeof char !== 'string') {
      return false;
    }
    /* eslint-disable-next-line */
    return /^[a-zA-Z]+$/.test(char);
  }

  const containsSpecialChars = (str) => {
       /* eslint-disable-next-line */
    const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`;

    const result = specialChars.split('').some(specialChar => {
      if (str.includes(specialChar)) {
        return true;
      }
      return false;
    });

    return result;
  }

  const validatePasswordPolicy = (current_password) => {
    var rules = {}
    setInvalid(Object.assign({}, invalid, { passwordpolicy: true, password:false }))


    rules[`mustnotcontainid`] = !(current_password.indexOf(userinfo.data.refnum) > -1)
    rules[`min12char`] = current_password.length >= 15;
    rules[`mustnotcontainname`] = (!(current_password.toLowerCase().indexOf(userinfo.data.firstName.toLowerCase()) > -1)) && (!(current_password.toLowerCase().indexOf(userinfo.data.lastName.toLowerCase()) > -1))
    rules[`beginwithchar`] = charIsLetter(current_password.substr(0, 1))
    rules[`onespecialchar`] = containsSpecialChars(current_password)

    /* eslint-disable-next-line */
    let numberCheck = /\d/
    rules[`onenumber`] = numberCheck.test(current_password)
    /* eslint-disable-next-line */
    let upperCheck = /[A-Z]/
    rules[`oneupperchar`] = upperCheck.test(current_password)
    /* eslint-disable-next-line */
    let lowerCheck = /[a-z]/
    rules[`onelowerchar`] = lowerCheck.test(current_password)

    var allowSubmit = true
    Object.keys(rules).forEach(item => {
      if (rules[`${item}`] === false) {
        allowSubmit = false
      }
    })
    setPasswordRules(Object.assign({}, passwordRules, rules))
    return allowSubmit
  }
  const validateOnSubmit = () => {
    var allowSubmit = true;
    var invalidJSON = {}

    if (userinfo.data.currentpassword === null) {
      Object.assign(invalidJSON, { currentpassword: true })
      allowSubmit = false
    }

    if (userinfo.data.password === null) {
      Object.assign(invalidJSON, { password: true })
      allowSubmit = false
    }

    if (userinfo.data.confirmpassword === null) {
      Object.assign(invalidJSON, { confirmpassword: true })
      allowSubmit = false
    }
    if (userinfo.data.password !== null && userinfo.data.confirmpassword !== null) {
      if (userinfo.data.password !== userinfo.data.confirmpassword) {
        Object.assign(invalidJSON, { passwordmatch: true })
        allowSubmit = false
      }
    }
    if (userinfo.data.password !== null) {
      if (!validatePasswordPolicy(userinfo.data.password)) {
        allowSubmit = false
      }
    }

    if (allowSubmit) {
      dispatch(saveExpiredPassword(Object.assign({}, {}, userinfo.data)))
      setRequestingSaveChangePassword(true)
    } else {
      setInvalid(Object.assign({}, invalid, invalidJSON))
    }
  }

  // const initialState = { currentpassword: null, password:null, confirmpassword:null,refnum:null }
  const [requestingGetUserInfo,setRequestingGetUserInfo] = useState(false)
  const [requestingGetUserDetails,setRequestingGetUserDetails] = useState(false)
  const [requestingSaveChangePassword,setRequestingSaveChangePassword] = useState(false)
  const isFirstRender = useRef(true)
  const history = useHistory()

  const parseCookie = str =>
  str
    .split(';')
    .map(v => v.split('='))
    .reduce((acc, v) => {
      acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
      return acc;
    }, {});



  const [backurl, setBackUrl] = useState(null)
  useEffect(() => {


          const url = parseCookie(document.cookie)?.from_app_url;
          setBackUrl(url)
  
  }, [])

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    
    if (requestingGetUserInfo && userinfo.requesting_get_successful) {
      setRequestingGetUserInfo(false)
    }
    if (requestingGetUserInfo && userinfo.message !== null) {
        toast.current.show({ severity: 'error', summary: "Retrieve User Info API", detail: userinfo.message, sticky: true });
        setRequestingGetUserInfo(false)
    }

    //Get userdetails
    if (requestingGetUserDetails && userdetails.requesting_get_successful) {
      fetchUserInfo()
      setRequestingGetUserDetails(false)
    }
    if (requestingGetUserDetails && userdetails.message !== null) {
      toast.current.show({ severity: 'error', summary: "Get User Details API", detail: userdetails.message, sticky: true });
      setRequestingGetUserDetails(false)
    }

    //Save Change Password
    if (requestingSaveChangePassword && userinfo.requesting_save_successful) {
      setRequestingSaveChangePassword(false)
      toast.current.show({ severity: 'success', summary: "", detail: "New password has been update successfully.", sticky: true });
      //route to my-profile
      //history.replace('/auth/my-profile')
      history.push({
        pathname: '/unauth/update-success',
        state: {
          title:"Password Reset",
          message:"Your new password has been updated.",
          redirecturl: backurl!==null ? backurl  : null
        },
      });
      
    }
    if (requestingSaveChangePassword && userinfo.message !== null) {
        toast.current.show({ severity: 'error', summary: "Save Change Password", detail: userinfo.message, sticky: true });
        setRequestingSaveChangePassword(false)
    }

  })

  const fetchUserDetails= ()=>{
   // dispatch(getUserDetails({}))
    //setRequestingGetUserDetails(true)
  }
  const fetchUserInfo = ()=>{
    // dispatch(getExpiredPasswordUserInfo({refnum:userdetails.data.refnum}))
    
    if(document.cookie.indexOf("username") > -1){
        var username = parseCookie(document.cookie)?.username;
        dispatch(getExpiredPasswordUserInfo({refnum:username}))
        setRequestingGetUserInfo(true)
    }

   // dispatch(getExpiredPasswordUserInfo({refnum:"1565494"}))
  //  setRequestingGetUserInfo(true)
  }

  useEffect(() => {
    //fetchUserDetails()
    fetchUserInfo()
    return ()=>{
 
    }
  }, [])

  const handleKeyDown = (event)=>{
    if (event.key === 'Enter') {
      if(requestingSaveChangePassword){
        return
      }
      validateOnSubmit()
    }
  }


  return <div className="rightside-container">
       <div className="rightside-body">
       <Toast ref={toast}/>
 
        <div className="activate-account-card">
          <div className="center">
            <div className="update-security-title">Update SSO Password</div>
            <div className="text-center change-password-subtitle">Your password has expired. You will need to change your password to continue logging in.</div>
            <div style={{height:15}}>&nbsp;&nbsp;</div>

            {/* <div style={{borderWidth:1,borderColor:'red',background:'red'}}>{JSON.stringify(userinfo)}</div> */}
            <Messages ref={messages}></Messages>
            <div className="security-question-inner">
            <div>
                <div className="label">Current Password</div>
                <div>
                  <div className="password-input">
                    <Password placeholder="Enter current password" ref={currentpasswordRef} icon={<MaskIcon passwordRef={currentpasswordRef} />} toggleMask feedback={false} value={userinfo.data.currentpassword || ''} onChange={(e) => {
                      resetValidation(['currentpassword'])
                      dispatch(updateExpiredPasswordUserInfo(Object.assign({}, userinfo.data, { currentpassword: e.target.value !== '' ? e.target.value : null })))
                    }} />
                  </div>
                  {/* <div className="last-changed">Last changed: 03/30/2022</div> */}
                  {invalid.currentpassword ? <small> <div className="p-error top-margin">Current Password is required</div></small> : null}

                </div>
              </div>

              <div className="current-password-spacer"></div>
              <div>
                <div className="label">New Password</div>
                <div className="password-input">

                  <Password placeholder="Enter new password" value={userinfo.data.password || ''} onChange={(e) => {

            
                    if (e.target.value !== '') {
                      //constantly checking policy
                      validatePasswordPolicy(e.target.value)
                    } else {
                      resetValidation(['password', 'passwordpolicy'])
                    }
                    dispatch(updateExpiredPasswordUserInfo(Object.assign({}, userinfo.data, { password: e.target.value !== '' ? e.target.value : null })))


                  }}  ref={passwordRef} icon={<MaskIcon passwordRef={passwordRef} />} toggleMask feedback={false} />
                </div>
                {invalid.password ? <small> <div className="p-error top-margin">Password is required</div></small> : null}
                {invalid.passwordpolicy ? <div className="policy-container">
                  <div className="left-password-policy">
                    <ul>
                    <div className={`${passwordRules.onelowerchar ? 'check' : 'uncheck'}`}><li>One lower case character</li></div>
                    <div className={`${passwordRules.oneupperchar ? 'check' : 'uncheck'}`}><li>One upper case character</li></div>
                    <div className={`${passwordRules.onenumber ? 'check' : 'uncheck'}`}><li>One number</li></div>
                    <div className={`${passwordRules.onespecialchar ? 'check' : 'uncheck'}`}><li>One special character</li></div>
                    </ul>
                  </div>
                  <div className="right-password-policy">
                    <ul>
                    <div className={`${passwordRules.beginwithchar ? 'check' : 'uncheck'}`}><li>Begins with a character</li></div>
                    <div className={`${passwordRules.min12char ? 'check' : 'uncheck'}`}><li>15 characters minimium</li></div>
                    <div className={`${passwordRules.mustnotcontainname ? 'check' : 'uncheck'}`}><li>Must not contain name</li></div>
                    <div className={`${passwordRules.mustnotcontainid ? 'check' : 'uncheck'}`}><li>Must not contain ID</li></div>
                    </ul>
                  </div>
                </div> : null}

              </div>

              <div>
                <div className="label">Confirm New Password</div>
                <div>
                  <div className="password-input">
                    <Password placeholder="Enter confirm new password" onKeyDown={handleKeyDown} ref={confirmpasswordRef} icon={<MaskIcon passwordRef={confirmpasswordRef} />} toggleMask feedback={false} value={userinfo.data.confirmpassword || ''} onChange={(e) => {
                      resetValidation(['confirmpassword', 'passwordmatch'])
                      dispatch(updateExpiredPasswordUserInfo(Object.assign({}, userinfo.data, { confirmpassword: e.target.value !== '' ? e.target.value : null })))
                    }} />
                  </div>
                  {invalid.confirmpassword ? <small> <div className="p-error top-margin">Confirm Password is required</div></small> : null}

                  {invalid.passwordmatch ? <small> <div className="p-error top-margin">Passwords must match</div></small> : null}

                </div>
              </div>
              <div className="row-btn"><span className="row-btn-link"><Button disabled={requestingSaveChangePassword} onClick={() => {
                if(requestingSaveChangePassword){
                  return
                }
                validateOnSubmit()
              }}>{requestingSaveChangePassword ? <i className="pi pi-spin pi-spinner"></i>:<span>&nbsp;&nbsp;</span>}&nbsp;&nbsp;Save Changes</Button></span></div>
              <div>
                <strong>Note:</strong> Passwords cannot be changed more than once per day and must not be one of the last 12 passwords used.
              </div>
              <div style={{paddingTop:"8px",paddingBottom:"8px",fontSize:"13px"}}>
                <strong>HRIS Single Sign On Users:</strong> If you access the HRIS SSO applications powered by <strong>Java</strong>, do not use the following special characters in your password: 
                <span style={{color:'red'}}>@%()&amp;-~` \</span>
              </div>
            </div>
          </div>
        </div>

  </div>
  </div>

}

export default PasswordExpired